import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import styled from '@emotion/styled';
import { DeviceIdentifierProvider, useDeviceIdentifier, useDetermineMobile } from '@myrealtrip/device-detect';
import React, { useMemo, useState, useEffect, useCallback, useRef, memo } from 'react';
import { keyframes, css, ThemeProvider } from '@emotion/react';
import { DEFAULT_COLORS, ResponsiveImage, Text, Icon, DEFAULT_THEME } from '@myrealtrip/web-ui';
import { media } from '@myrealtrip/modash';
import { weblog } from '@myrealtrip/logger';
import { helper } from '@myrealtrip/frontend-weblog';
import { ErrorBoundary } from '@myrealtrip/react';
import { axiosInstance } from '@myrealtrip/fetch';
import { useQuery, QueryClient, QueryClientProvider, useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { css as css$1 } from '@emotion/css';

var AdsScreenNameMap = {
    offer_list: 'offer_list',
    main: 'main',
    city: 'city',
    tourticket: 'tourticket',
    search_home: 'search_home',
    union_search: 'union_search',
    hotel_search_home: 'hotel_search_home',
    hotel_offer_detail: 'hotel_offer_detail',
    checkout_reservation_detail: 'checkout_reservation_detail',
    checkout_complete: 'checkout_complete',
    reservation_history_ongoing: 'reservation_history_ongoing',
    all_flights_main: 'all_flights_main',
    intl_flights_loading: 'intl_flights_loading',
    intl_flights_list: 'intl_flights_list',
    intl_flights_reservation_complete: 'intl_flights_reservation_complete',
    intl_flights_ticketIssue: 'intl_flights_ticketIssue',
    dom_flights_loading: 'dom_flights_loading',
    dom_flights_list: 'dom_flights_list',
    dom_flights_ticketIssue: 'dom_flights_ticketIssue',
    chat_list: 'chat_list',
};
var AdsBannerSectionNameMap = {
    AD_IMAGE_BANNERS_1: 'AD_IMAGE_BANNERS_1', // 직접호출 구좌
    AD_IMAGE_BANNERS_DOMESTIC_1: 'AD_IMAGE_BANNERS_DOMESTIC_1', // 통합숙소 상품상세(국내) 1번 구좌
    AD_IMAGE_BANNERS_INTERNATIONAL_1: 'AD_IMAGE_BANNERS_INTERNATIONAL_1', // 통합숙소 상품상세(해외) 1번 구좌
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1: 'CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1', // 다이나믹 화면 구좌
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_DOMESTIC_1: 'CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_DOMESTIC_1', // 통합숙소 홈(국내) 1번 구좌
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_INTERNATIONAL_1: 'CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_INTERNATIONAL_1', // 통합숙소 홈(해외) 1번 구좌
};
var AdsInteractiveBannerSectionNameMap = {
    INTERACTIVE_BANNER_IMAGE_AD_CONTAINER_1: 'INTERACTIVE_BANNER_IMAGE_AD_CONTAINER_1',
};
var AdsBannerSectionVerticalIndexMap = {
    AD_IMAGE_BANNERS_1: 1,
    AD_IMAGE_BANNERS_DOMESTIC_1: 1,
    AD_IMAGE_BANNERS_INTERNATIONAL_1: 1,
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1: 1,
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_DOMESTIC_1: 1,
    CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_INTERNATIONAL_1: 1,
    INTERACTIVE_BANNER_IMAGE_AD_CONTAINER_1: 1,
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var skeletonAnime = keyframes(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  0% {\n    transform: translateX(0);\n    opacity: 0;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n"], ["\n  0% {\n    transform: translateX(0);\n    opacity: 0;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n"])));
var SkeletonFallback = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  overflow: hidden;\n\n  &:after {\n    animation: ", " 1.5s infinite ease-in;\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  overflow: hidden;\n\n  &:after {\n    animation: ", " 1.5s infinite ease-in;\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"])), DEFAULT_COLORS.gray.s80, skeletonAnime);
var templateObject_1$c, templateObject_2$a;

var _a;
var AUTO_SLIDE_DURATION = 5000;
var AdsBannerListDefaultPropsMap = (_a = {},
    _a[AdsScreenNameMap.main] = {
        CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1: {
            desktop: {
                margin: '64px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '32px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.tourticket] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '56px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '32px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.city] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '56px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '32px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.offer_list] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '0 0 36px',
                borderRadius: 12,
            },
            mobile: {
                margin: '4px 0 16px',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.checkout_complete] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '0 0 24px',
            },
            mobile: {
                margin: '0 0 24px',
            },
        },
    },
    _a[AdsScreenNameMap.reservation_history_ongoing] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '56px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '40px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.checkout_reservation_detail] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '20px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '20px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.chat_list] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '40px 0 24px',
                borderRadius: 12,
            },
            mobile: {
                margin: '8px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.search_home] = {
        AD_IMAGE_BANNERS_1: {
            mobile: {
                margin: '12px 0 0',
                borderRadius: 12,
                isHiddenApiLoader: true,
            },
        },
    },
    _a[AdsScreenNameMap.union_search] = {
        CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1: {
            mobile: {
                margin: '0 0 12px',
                borderRadius: 12,
                padding: '8px 12px 0',
            },
            desktop: {
                margin: '12px 0 24px',
                borderRadius: 12,
                padding: '0 18px',
            },
        },
    },
    _a[AdsScreenNameMap.hotel_search_home] = {
        CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_DOMESTIC_1: {
            desktop: {
                margin: '40px 0 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 2px',
                borderRadius: 12,
            },
        },
        CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_INTERNATIONAL_1: {
            desktop: {
                margin: '40px 0 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 2px',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.hotel_offer_detail] = {
        AD_IMAGE_BANNERS_DOMESTIC_1: {
            desktop: {
                margin: '0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0',
                borderRadius: 12,
            },
        },
        AD_IMAGE_BANNERS_INTERNATIONAL_1: {
            desktop: {
                margin: '0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.all_flights_main] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '56px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '40px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.intl_flights_loading] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '40px 0 0',
                borderRadius: 12,
                isUnclickable: true,
                isHiddenApiLoader: true,
            },
            mobile: {
                margin: '40px 0 0',
                borderRadius: 12,
                isUnclickable: true,
                isHiddenApiLoader: true,
            },
        },
    },
    _a[AdsScreenNameMap.intl_flights_list] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '24px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 16px',
            },
        },
    },
    _a[AdsScreenNameMap.intl_flights_reservation_complete] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '24px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 24px',
            },
        },
    },
    _a[AdsScreenNameMap.intl_flights_ticketIssue] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '40px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '12px 0',
                borderRadius: 12,
            },
        },
    },
    _a[AdsScreenNameMap.dom_flights_loading] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '40px 0 0',
                borderRadius: 12,
                isUnclickable: true,
                isHiddenApiLoader: true,
            },
            mobile: {
                margin: '40px 0 0',
                borderRadius: 12,
                isUnclickable: true,
                isHiddenApiLoader: true,
            },
        },
    },
    _a[AdsScreenNameMap.dom_flights_list] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '24px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 16px',
            },
        },
    },
    _a[AdsScreenNameMap.dom_flights_ticketIssue] = {
        AD_IMAGE_BANNERS_1: {
            desktop: {
                margin: '24px 0',
                borderRadius: 12,
            },
            mobile: {
                margin: '0 0 24px',
            },
        },
    },
    _a);
// Shrinking Banner 상수
var SHRINKING_BANNER_CONSTANTS = {
    MIN_HEIGHT: 58,
    CONTAINER_PADDING: 12,
    SNAP_DURATION: 100,
    SWIPE_THRESHOLD: 10,
    PROGRESS_UPDATE_THRESHOLD: 0.01,
    TOUCH_MOVE_UPDATE_THRESHOLD: 0.005,
    EXPANDED_OPACITY_THRESHOLD: 0.3,
    COMPACT_OPACITY_THRESHOLD: 0.5,
    COMPACT_FADE_START: 0.15,
    COMPACT_FADE_END: 0.8,
    MIN_BANNER_HEIGHT: 40,
    CTA_GAP: 10,
    CTA_HEIGHT: 49,
};

function SkeletonComponent(props) {
    var screenName = props.screenName, sectionName = props.sectionName, padding = props.padding;
    var _a = useDeviceIdentifier(), isMobile = _a.isMobile, deviceType = _a.deviceType;
    var _b = useMemo(function () {
        var _a, _b;
        var defaults = screenName && sectionName
            ? (_b = (_a = AdsBannerListDefaultPropsMap[screenName]) === null || _a === void 0 ? void 0 : _a[sectionName]) === null || _b === void 0 ? void 0 : _b[isMobile ? 'mobile' : 'desktop']
            : undefined;
        var keys = [
            'margin',
            'borderRadius',
        ];
        return Object.fromEntries(keys.map(function (key) { return [key, (props === null || props === void 0 ? void 0 : props[key]) === undefined ? defaults === null || defaults === void 0 ? void 0 : defaults[key] : props[key]]; }));
    }, [screenName, sectionName, isMobile]), decidedMargin = _b.margin, decidedBorderRadius = _b.borderRadius;
    return (jsx(Container$7, { margin: decidedMargin, padding: padding, children: jsx(Skeleton, { borderRadius: Number(decidedBorderRadius || 0), isMobile: deviceType !== 'desktop' }) }));
}
var Container$7 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  padding: ", ";\n  margin: ", ";\n"], ["\n  padding: ", ";\n  margin: ", ";\n"])), function (_a) {
    var padding = _a.padding;
    return (typeof padding === 'number' ? "".concat(padding, "px") : padding || '0');
}, function (_a) {
    var margin = _a.margin;
    return (typeof margin === 'number' ? "".concat(margin, "px") : margin || '0');
});
var Skeleton = styled(SkeletonFallback)(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  border-radius: ", "px;\n  aspect-ratio: ", ";\n"], ["\n  border-radius: ", "px;\n  aspect-ratio: ", ";\n"])), function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius;
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '10 / 3' : '6 / 1');
});
function AdsBannerListSkeleton(props) {
    return (jsx(DeviceIdentifierProvider, { children: jsx(SkeletonComponent, __assign({}, props)) }));
}
var templateObject_1$b, templateObject_2$9;

var optimizedImageStyle = css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  // \uC774\uBBF8\uC9C0 \uCD5C\uC801\uD654 \uCC98\uB9AC\n  image-rendering: crisp-edges;\n  image-rendering: -moz-crisp-edges; /* Firefox */\n  image-rendering: -o-crisp-edges; /* Opera */\n  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */\n  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */\n  transform: translateZ(0);\n  backface-visibility: hidden;\n"], ["\n  // \uC774\uBBF8\uC9C0 \uCD5C\uC801\uD654 \uCC98\uB9AC\n  image-rendering: crisp-edges;\n  image-rendering: -moz-crisp-edges; /* Firefox */\n  image-rendering: -o-crisp-edges; /* Opera */\n  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */\n  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */\n  transform: translateZ(0);\n  backface-visibility: hidden;\n"])));
var OptimizedImage = styled.img(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), optimizedImageStyle);
var templateObject_1$a, templateObject_2$8;

function getDeviceOptimalUrl(_a) {
    var baseUrl = _a.baseUrl, desktopUrl = _a.desktopUrl, isMobileWeb = _a.isMobileWeb, isWebView = _a.isWebView;
    if (!baseUrl)
        return '';
    // 웹뷰 딥링크 누락보완(인앱브라우저 기본)
    if (isWebView && !baseUrl.startsWith('mrt://'))
        return "mrt://web?url=".concat(encodeURIComponent(baseUrl));
    // 모웹 외에는 url 링크 적용
    if (!isMobileWeb)
        return baseUrl;
    // 모웹 + url이 딥링크인 경우 웹링크(desktop) 백업
    return baseUrl.startsWith('mrt://') && !!desktopUrl ? desktopUrl : baseUrl;
}

var useChargedImpressionLog = weblog.useChargedImpressionLog;
var sendClickLog$1 = helper.sendClickLog;
function AdsBannerItem(_a) {
    var banner = _a.banner, uniqueScreenName = _a.uniqueScreenName, pageCategory = _a.pageCategory, borderRadius = _a.borderRadius, isUnclickable = _a.isUnclickable, extraLogData = _a.extraLogData, bannerIndex = _a.bannerIndex, activeBannerIndex = _a.activeBannerIndex, totalBannerCount = _a.totalBannerCount;
    var id = banner.id, redirectTo = banner.redirectTo, isExternalObject = banner.isExternalObject, imageUrl = banner.imageUrl, baseLogData = banner.baseLogData;
    var isLoadBannerImage = Math.abs(activeBannerIndex - bannerIndex) <= 1 ||
        Math.abs(activeBannerIndex - bannerIndex) === totalBannerCount - 1;
    var _b = useDeviceIdentifier(), deviceType = _b.deviceType, isMobile = _b.isMobile, isMobileWeb = _b.isMobileWeb, isWebView = _b.isWebView;
    var linkUrl = useMemo(function () {
        return getDeviceOptimalUrl({
            baseUrl: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.url,
            desktopUrl: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop,
            isMobileWeb: isMobileWeb,
            isWebView: isWebView,
        });
    }, [isMobileWeb, redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.url]);
    var logBody = {
        screenName: uniqueScreenName,
        pageCategory: pageCategory || '',
        eventName: 'ad_banner',
    };
    var logBodyParamsField = __assign(__assign({}, baseLogData), extraLogData);
    var handleClickBanner = function () {
        if (isUnclickable)
            return;
        sendClickLog$1(__assign(__assign({}, logBody), logBodyParamsField));
        if (!linkUrl)
            return;
        if (isWebView) {
            location.href = linkUrl;
            return;
        }
        window.open(linkUrl, '_blank');
    };
    var impressionRef = useChargedImpressionLog(__assign(__assign({}, logBody), { params: logBodyParamsField, chargedImpressionOptions: {
            key: "advertisement-banner-".concat(uniqueScreenName, "-").concat(id),
        } })).impressionRef;
    return (jsxs(Container$6, { onClick: handleClickBanner, cursor: isUnclickable || !linkUrl ? 'default' : 'pointer', borderRadius: borderRadius, isMobile: deviceType !== 'desktop', children: [jsx("div", { ref: impressionRef, children: jsx(BannerImage$1, { src: imageUrl, alt: "advertisement-banner-".concat(uniqueScreenName, "-").concat(id), lazy: isLoadBannerImage ? 'unused' : 'intersect', placeholder: jsx(SkeletonFallback, {}) }) }), isExternalObject && (jsx(GradientOverlay, { children: jsx(ExternalAdsText, { typography: isMobile ? 'captionNormal12' : 'captionNormal13', children: "\uAD11\uACE0" }) }))] }));
}
var Container$6 = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  border-radius: ", "px;\n  flex: 0 0 100%;\n  min-width: 0;\n  background-color: ", ";\n  cursor: ", ";\n  aspect-ratio: ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  border-radius: ", "px;\n  flex: 0 0 100%;\n  min-width: 0;\n  background-color: ", ";\n  cursor: ", ";\n  aspect-ratio: ", ";\n"])), function (_a) {
    var _b = _a.borderRadius, borderRadius = _b === void 0 ? 0 : _b;
    return borderRadius;
}, DEFAULT_COLORS.gray.s200, function (_a) {
    var cursor = _a.cursor;
    return cursor;
}, function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '10 / 3' : '6 / 1');
});
var BannerImage$1 = styled(ResponsiveImage)(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  ", ";\n"])), optimizedImageStyle);
var GradientOverlay = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    111deg,\n    rgba(0, 0, 0, 0) 58.64%,\n    rgba(0, 0, 0, 0.08) 77.12%,\n    rgba(0, 0, 0, 0.4) 95.97%\n  );\n  z-index: 1;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    111deg,\n    rgba(0, 0, 0, 0) 58.64%,\n    rgba(0, 0, 0, 0.08) 77.12%,\n    rgba(0, 0, 0, 0.4) 95.97%\n  );\n  z-index: 1;\n  pointer-events: none;\n"])));
var ExternalAdsText = styled(Text)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n  color: ", ";\n  z-index: 1;\n"], ["\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n  color: ", ";\n  z-index: 1;\n"])), DEFAULT_COLORS.gray.s80);
var templateObject_1$9, templateObject_2$7, templateObject_3$5, templateObject_4$5;

var CookieKey;
(function (CookieKey) {
    CookieKey["PID"] = "pid";
    CookieKey["LOG_PID"] = "log_pid";
    CookieKey["INTERACTIVE_BANNER_ID"] = "interactive_banner_id";
})(CookieKey || (CookieKey = {}));
var CookieManager = /** @class */ (function () {
    function CookieManager() {
    }
    CookieManager.get = function (key) {
        return Cookies.get(key);
    };
    CookieManager.getJSON = function (key) {
        return Cookies.getJSON(key);
    };
    CookieManager.set = function (key, value, options) {
        return Cookies.set(key, value, options);
    };
    CookieManager.remove = function (key, options) {
        Cookies.remove(key, options);
    };
    return CookieManager;
}());

var queryKey = ['useGetAdsBanners'];
// URL 생성 개선
var buildAdsBannerUrl = function (screenName, sectionName) {
    var baseUrl = '/ad/v1/traveler/exposure/cpt/ad';
    var searchParams = new URLSearchParams({
        screenName: screenName,
        sectionName: sectionName,
    });
    // PID 파라미터 추가 (있는 경우에만)
    var pid = CookieManager.get(CookieKey.PID) || CookieManager.get(CookieKey.LOG_PID);
    if (pid) {
        searchParams.append('pid', pid);
    }
    return "".concat(baseUrl, "?").concat(searchParams.toString());
};
var queryFn = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var url;
    var screenName = _b.screenName, sectionName = _b.sectionName;
    return __generator(this, function (_c) {
        url = buildAdsBannerUrl(screenName, sectionName);
        return [2 /*return*/, axiosInstance.get(url)];
    });
}); };
var useGetAdsBanners = function (_a) {
    var screenName = _a.screenName, sectionName = _a.sectionName, enabled = _a.enabled, _b = _a.isMockDataMode, isMockDataMode = _b === void 0 ? false : _b;
    if (isMockDataMode) {
        return { data: MOCK_ADS_BANNERS, isLoading: false };
    }
    var _c = useQuery({
        queryKey: __spreadArray(__spreadArray([], queryKey, true), [screenName, sectionName], false),
        queryFn: function () { return queryFn({ screenName: screenName, sectionName: sectionName }); },
        enabled: [screenName, sectionName, enabled].every(function (is) { return is; }),
        useErrorBoundary: true,
        select: function (res) { var _a; return ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || {}; },
        retry: 1,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
    }), data = _c.data, query = __rest(_c, ["data"]);
    return __assign({ data: data }, query);
};
var MOCK_ADS_BANNERS = {
    exposureMeta: {
        name: 'MOCK_ADS_BANNERS',
        platform: 'DESKTOP',
        screenName: 'main',
        screenTitle: 'main',
        sectionName: 'CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1',
        sectionTitle: 'CAROUSEL_ONE_COLUMN_IMAGE_AD_CONTAINER_1',
        description: 'MOCK_ADS_BANNERS',
    },
    inventories: [
        {
            adMeta: {
                id: 1,
                groupId: 1,
                campaignId: 1,
                redirectTo: {
                    url: 'https://www.google.com',
                    desktop: 'https://www.google.com',
                    mobile: 'https://www.google.com',
                },
                groupTargetId: 1,
                groupTargetAttributes: null,
            },
            campaignObjectType: 'EXTERNAL',
            exposeType: 'AUTO',
            name: 'MOCK_BANNER_1',
            paginationText: {
                prefix: '1',
                page: '1/5',
            },
            image: 'https://picsum.photos/2880/480',
        },
        {
            adMeta: {
                id: 2,
                groupId: 2,
                campaignId: 2,
                redirectTo: {
                    url: 'https://www.google.com',
                    desktop: 'https://www.google.com',
                    mobile: 'https://www.google.com',
                },
                groupTargetId: 1,
                groupTargetAttributes: null,
            },
            campaignObjectType: 'INTERNAL',
            exposeType: 'AUTO',
            name: 'MOCK_BANNER_2',
            paginationText: {
                prefix: '2',
                page: '2/5',
            },
            image: 'https://picsum.photos/2880/480',
        },
        {
            adMeta: {
                id: 3,
                groupId: 3,
                campaignId: 3,
                redirectTo: {
                    url: '',
                    desktop: '',
                    mobile: '',
                },
                groupTargetId: 1,
                groupTargetAttributes: null,
            },
            campaignObjectType: 'EXTERNAL',
            exposeType: 'AUTO',
            name: 'MOCK_BANNER_3',
            paginationText: {
                prefix: '3',
                page: '3/5',
            },
            image: 'https://picsum.photos/2880/480',
        },
        {
            adMeta: {
                id: 4,
                groupId: 4,
                campaignId: 4,
                redirectTo: {
                    url: 'https://www.google.com',
                    desktop: 'https://www.google.com',
                    mobile: 'https://www.google.com',
                },
                groupTargetId: 1,
                groupTargetAttributes: null,
            },
            campaignObjectType: 'INTERNAL',
            exposeType: 'AUTO',
            name: 'MOCK_BANNER_4',
            paginationText: {
                prefix: '4',
                page: '4/5',
            },
            image: 'https://picsum.photos/2880/480',
        },
        {
            adMeta: {
                id: 5,
                groupId: 5,
                campaignId: 5,
                redirectTo: {
                    url: 'https://www.google.com',
                    desktop: '',
                    mobile: '',
                },
                groupTargetId: 1,
                groupTargetAttributes: null,
            },
            campaignObjectType: 'EXTERNAL',
            exposeType: 'AUTO',
            name: 'MOCK_BANNER_5',
            paginationText: {
                prefix: '5',
                page: '5/5',
            },
            image: 'https://picsum.photos/2880/480',
        },
    ],
    type: 'IMAGE_BANNER',
    adaptedUserSegments: null,
};

var convertBannersApiToRender = function (bannersApiResponse) {
    var _a;
    if (!((_a = bannersApiResponse === null || bannersApiResponse === void 0 ? void 0 : bannersApiResponse.inventories) === null || _a === void 0 ? void 0 : _a.length))
        return [];
    var exposureMeta = bannersApiResponse.exposureMeta, inventories = bannersApiResponse.inventories, adaptedUserSegments = bannersApiResponse.adaptedUserSegments;
    return inventories.map(function (banner, index) {
        var _a = banner.adMeta, id = _a.id, redirectTo = _a.redirectTo, groupId = _a.groupId, campaignId = _a.campaignId, groupTargetId = _a.groupTargetId, groupTargetAttributes = _a.groupTargetAttributes, paginationText = banner.paginationText, name = banner.name, image = banner.image, campaignObjectType = banner.campaignObjectType;
        var isExternalObject = campaignObjectType === 'EXTERNAL';
        return {
            id: id,
            screenName: exposureMeta.screenName,
            sectionName: exposureMeta.sectionName,
            redirectTo: redirectTo,
            isExternalObject: isExternalObject,
            pagination: paginationText.page,
            imageUrl: image,
            baseLogData: {
                item_kind: 'banner',
                ad_data: {
                    ad_type: 'IMAGE_BANNER',
                    ad_inventory_id: id,
                    ad_inventory_name: name,
                    ad_group_id: groupId,
                    ad_campaign_id: campaignId,
                    ad_section_name: exposureMeta.sectionName,
                    ad_section_title: exposureMeta.sectionTitle,
                    ad_campaign_object: campaignObjectType,
                    ad_group_target_id: groupTargetId || 0,
                    ad_group_target_attributes: groupTargetAttributes || null,
                    ad_adapted_user_segments: adaptedUserSegments || null,
                },
                item_horizon_index: index,
                section_vertical_index: AdsBannerSectionVerticalIndexMap[(exposureMeta === null || exposureMeta === void 0 ? void 0 : exposureMeta.sectionName) || ''],
            },
        };
    });
};
var convertBannersDynamicToRender = function (bannersDynamicResponse) {
    if (!(bannersDynamicResponse === null || bannersDynamicResponse === void 0 ? void 0 : bannersDynamicResponse.length))
        return [];
    return bannersDynamicResponse.map(function (banner) {
        var _a, _b, _c, _d, _e;
        var sectionMeta = banner.sectionMeta, loggingMeta = banner.loggingMeta, body = banner.body;
        var baseLogData = (_a = loggingMeta === null || loggingMeta === void 0 ? void 0 : loggingMeta.BIZLOG) === null || _a === void 0 ? void 0 : _a.data;
        var id = ((_b = baseLogData === null || baseLogData === void 0 ? void 0 : baseLogData.ad_data) === null || _b === void 0 ? void 0 : _b.ad_inventory_id) || 0;
        var index = body.index, image = body.image;
        var page = index.text;
        var isExternalObject = ((_c = baseLogData === null || baseLogData === void 0 ? void 0 : baseLogData.ad_data) === null || _c === void 0 ? void 0 : _c.ad_campaign_object) === 'EXTERNAL';
        return {
            id: id,
            screenName: ((_d = loggingMeta === null || loggingMeta === void 0 ? void 0 : loggingMeta.BIZLOG) === null || _d === void 0 ? void 0 : _d.screen) || '',
            sectionName: baseLogData === null || baseLogData === void 0 ? void 0 : baseLogData.ad_data.ad_section_name,
            redirectTo: {
                url: ((_e = sectionMeta === null || sectionMeta === void 0 ? void 0 : sectionMeta.linkMeta) === null || _e === void 0 ? void 0 : _e.SECTION) || '',
                desktop: null,
                mobile: null,
            },
            isExternalObject: isExternalObject,
            pagination: page || '',
            imageUrl: (image === null || image === void 0 ? void 0 : image.url) || '',
            baseLogData: baseLogData,
        };
    });
};

var useGenerateBannersRenderList = function (_a) {
    var _b, _c;
    var screenName = _a.screenName, sectionName = _a.sectionName, prefetchedBanners = _a.prefetchedBanners, isMockDataMode = _a.isMockDataMode, fetchDelay = _a.fetchDelay;
    var _d = prefetchedBanners || {}, bannersData = _d.bannersData, category = _d.category;
    var isRenderByDynamic = category === 'dynamicV4' && !!bannersData;
    var _e = useState(!fetchDelay), isDelayedEnabled = _e[0], setIsDelayedEnabled = _e[1];
    useEffect(function () {
        if (!fetchDelay || bannersData)
            return;
        var timer = setTimeout(function () {
            setIsDelayedEnabled(true);
        }, fetchDelay);
        return function () { return clearTimeout(timer); };
    }, [fetchDelay, bannersData]);
    var _f = useGetAdsBanners({
        screenName: screenName,
        sectionName: sectionName,
        enabled: !bannersData && isDelayedEnabled,
        isMockDataMode: isMockDataMode,
    }), bannersApiData = _f.data, isLoading = _f.isLoading;
    var banners = isRenderByDynamic
        ? convertBannersDynamicToRender(bannersData)
        : convertBannersApiToRender(bannersData || bannersApiData);
    return {
        isLoading: bannersData ? false : isLoading,
        banners: banners,
        uniqueScreenName: (!prefetchedBanners
            ? screenName
            : (_b = banners[0]) === null || _b === void 0 ? void 0 : _b.screenName),
        uniqueSectionName: !prefetchedBanners ? sectionName : (_c = banners[0]) === null || _c === void 0 ? void 0 : _c.sectionName,
    };
};

function BannerSlideButton(_a) {
    var onClick = _a.onClick, isNextButton = _a.isNextButton, isHidden = _a.isHidden;
    var isMobile = useDetermineMobile();
    if (isHidden || isMobile)
        return null;
    var iconName = isNextButton ? 'IcoChevronRight' : 'IcoChevronLeft';
    return (jsx(Button, { isNextButton: isNextButton, onClick: onClick, className: "banner-slide-button", children: jsx(Icon, { name: iconName, color: DEFAULT_COLORS.gray.s800, size: 24 }) }));
}
var Button = styled.button(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  ", ": -20px;\n  transform: translateY(-50%);\n  display: none;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border: 1.5px solid ", " !important;\n  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\n  border-radius: 50%;\n  z-index: 1;\n\n  ", " {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden; // \uC0C1\uC704\uC5D0\uC11C \uD638\uBC84 \uC2DC, \uD074\uB798\uC2A4 \uD0C0\uAC9F\uC73C\uB85C visible\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  ", ": -20px;\n  transform: translateY(-50%);\n  display: none;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border: 1.5px solid ", " !important;\n  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.05);\n  border-radius: 50%;\n  z-index: 1;\n\n  ", " {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden; // \uC0C1\uC704\uC5D0\uC11C \uD638\uBC84 \uC2DC, \uD074\uB798\uC2A4 \uD0C0\uAC9F\uC73C\uB85C visible\n  }\n"])), function (_a) {
    var isNextButton = _a.isNextButton;
    return (isNextButton ? 'right' : 'left');
}, DEFAULT_COLORS.gray.s200, media.minMobile);
var templateObject_1$8;

function AdsBanners(props) {
    var screenName = props.screenName, sectionName = props.sectionName, pageCategory = props.pageCategory, _a = props.autoSlideDuration, autoSlideDuration = _a === void 0 ? AUTO_SLIDE_DURATION : _a, extraLogData = props.extraLogData, prefetchedBanners = props.prefetchedBanners, isMockDataMode = props.isMockDataMode, _b = props.fetchDelay, fetchDelay = _b === void 0 ? 0 : _b;
    var isMobile = useDeviceIdentifier().isMobile;
    var _c = useGenerateBannersRenderList({
        screenName: screenName,
        sectionName: sectionName,
        prefetchedBanners: prefetchedBanners,
        isMockDataMode: isMockDataMode,
        fetchDelay: fetchDelay,
    }), isLoading = _c.isLoading, banners = _c.banners, uniqueScreenName = _c.uniqueScreenName, uniqueSectionName = _c.uniqueSectionName;
    var _d = useMemo(function () {
        var _a, _b, _c;
        if (!uniqueScreenName || !uniqueSectionName)
            return {};
        var deviceKey = isMobile ? 'mobile' : 'desktop';
        var screenDefaults = AdsBannerListDefaultPropsMap[uniqueScreenName];
        var defaults = (_b = (_a = screenDefaults === null || screenDefaults === void 0 ? void 0 : screenDefaults[uniqueSectionName]) === null || _a === void 0 ? void 0 : _a[deviceKey]) !== null && _b !== void 0 ? _b : (_c = Object.values(screenDefaults !== null && screenDefaults !== void 0 ? screenDefaults : {})[0]) === null || _c === void 0 ? void 0 : _c[deviceKey];
        var keys = [
            'margin',
            'padding',
            'borderRadius',
            'isUnclickable',
            'isHiddenApiLoader',
        ];
        return Object.fromEntries(keys.map(function (key) { return [key, props[key] === undefined ? defaults === null || defaults === void 0 ? void 0 : defaults[key] : props[key]]; }));
    }, [uniqueScreenName, uniqueSectionName, isMobile]), decidedMargin = _d.margin, decidedPadding = _d.padding, decidedBorderRadius = _d.borderRadius, decidedIsUnclickable = _d.isUnclickable, decidedIsHiddenApiLoader = _d.isHiddenApiLoader;
    var bannerCount = banners.length;
    var isSingleBanner = bannerCount <= 1;
    var _e = useState(0), activeBannerIndex = _e[0], setActiveBannerIndex = _e[1];
    var activeBanner = banners[activeBannerIndex];
    var emblaAutoplay = useMemo(function () {
        if (isSingleBanner)
            return undefined;
        return [Autoplay({ delay: autoSlideDuration, stopOnInteraction: false })];
    }, [isSingleBanner, autoSlideDuration]);
    var _f = useEmblaCarousel({
        loop: !isSingleBanner,
        watchDrag: isMobile && !isSingleBanner,
    }, emblaAutoplay), emblaRef = _f[0], emblaApi = _f[1];
    var resetAutoplay = useCallback(function () {
        var _a, _b;
        (_b = (_a = emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.plugins()) === null || _a === void 0 ? void 0 : _a.autoplay) === null || _b === void 0 ? void 0 : _b.reset();
    }, [emblaApi]);
    var scrollPrev = useCallback(function () {
        if (!emblaApi)
            return;
        emblaApi.scrollPrev();
        resetAutoplay();
    }, [emblaApi, resetAutoplay]);
    var scrollNext = useCallback(function () {
        if (!emblaApi)
            return;
        emblaApi.scrollNext();
        resetAutoplay();
    }, [emblaApi, resetAutoplay]);
    useEffect(function () {
        if (!emblaApi)
            return;
        var onSelect = function () {
            setActiveBannerIndex(emblaApi.selectedScrollSnap());
        };
        emblaApi.on('select', onSelect);
        emblaApi.on('pointerUp', resetAutoplay);
        onSelect();
        return function () {
            emblaApi.off('select', onSelect);
            emblaApi.off('pointerUp', resetAutoplay);
        };
    }, [emblaApi, resetAutoplay]);
    if (!(banners === null || banners === void 0 ? void 0 : banners.length) && (!isLoading || (isLoading && decidedIsHiddenApiLoader)))
        return null;
    return (jsx(Container$5, { margin: decidedMargin, padding: decidedPadding, children: isLoading ? (jsx(AdsBannerListSkeleton, { borderRadius: decidedBorderRadius })) : (jsxs(EntireWrapper, { children: [!isSingleBanner && (jsx(CountBadge, { children: jsx(Text, { typography: "captionBold13", children: activeBanner === null || activeBanner === void 0 ? void 0 : activeBanner.pagination }) })), jsx(BannerSlideButton, { onClick: scrollPrev, isHidden: isSingleBanner }), jsx(BannerSlideButton, { isNextButton: true, onClick: scrollNext, isHidden: isSingleBanner }), jsx(SlideContainer$1, { ref: emblaRef, children: jsx(SlideList$1, { children: React.Children.toArray(banners.map(function (banner, index) { return (jsx(AdsBannerItem, { banner: banner, bannerIndex: index, activeBannerIndex: activeBannerIndex, totalBannerCount: banners.length, uniqueScreenName: uniqueScreenName, pageCategory: pageCategory, borderRadius: decidedBorderRadius, isUnclickable: decidedIsUnclickable, extraLogData: extraLogData })); })) }) })] })) }));
}
var queryClient = new QueryClient();
function AdsBannerList(props) {
    return (jsx(DeviceIdentifierProvider, { children: jsx(ThemeProvider, { theme: DEFAULT_THEME, children: jsx(ErrorBoundary, { name: "AdsBannerList", fallback: null, children: jsx(QueryClientProvider, { client: queryClient, children: jsx(AdsBanners, __assign({}, props)) }) }) }) }));
}
var Container$5 = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  margin: ", ";\n  padding: ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  margin: ", ";\n  padding: ", ";\n"])), function (_a) {
    var margin = _a.margin;
    return (typeof margin === 'number' ? "".concat(margin, "px") : margin || '0');
}, function (_a) {
    var padding = _a.padding;
    return (typeof padding === 'number' ? "".concat(padding, "px") : padding || '0');
});
var EntireWrapper = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  ", " {\n    &:hover .banner-slide-button {\n      visibility: visible;\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  ", " {\n    &:hover .banner-slide-button {\n      visibility: visible;\n    }\n  }\n"])), media.minMobile);
var SlideContainer$1 = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var SlideList$1 = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  display: flex; // embla-carousel-react \uC0AC\uC6A9 \uC2DC, \uC2AC\uB77C\uC774\uB4DC\uB4E4 flex-container \uB7A9\uD551 \uD544\uC694\n"], ["\n  display: flex; // embla-carousel-react \uC0AC\uC6A9 \uC2DC, \uC2AC\uB77C\uC774\uB4DC\uB4E4 flex-container \uB7A9\uD551 \uD544\uC694\n"])));
var CountBadge = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  box-sizing: border-box;\n  padding: 3px 8px;\n  background-color: ", "B3;\n  border-radius: 16px;\n  z-index: 1;\n\n  > span {\n    color: ", ";\n    transform: translateY(0.5px);\n  }\n"], ["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  box-sizing: border-box;\n  padding: 3px 8px;\n  background-color: ", "B3;\n  border-radius: 16px;\n  z-index: 1;\n\n  > span {\n    color: ", ";\n    transform: translateY(0.5px);\n  }\n"])), DEFAULT_COLORS.gray.s1000, DEFAULT_COLORS.white);
var templateObject_1$7, templateObject_2$6, templateObject_3$4, templateObject_4$4, templateObject_5$4;

// TODO(ads,P2) : 응답값 추가될 경우 Response 타입변경(제너릭 1번 및 2번 내부인자)
var mutationFn = function (inventoryId) {
    return axiosInstance.put("/ad/v1/traveler/exposure/cpt/ad/inventory/".concat(inventoryId, "/_close"));
};
function usePutCloseExposureInteractiveBanner() {
    return useMutation({
        mutationFn: mutationFn,
    });
}

function ExternalBannerLabel(_a) {
    var top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return (jsx(Label, { typography: "captionNormal12", top: top, bottom: bottom, left: left, right: right, children: "\uAD11\uACE0" }));
}
var Label = styled(Text)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n  color: ", ";\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n  color: ", ";\n  z-index: 1;\n"])), function (_a) {
    var top = _a.top;
    return (typeof top === 'number' ? "".concat(top, "px") : top);
}, function (_a) {
    var bottom = _a.bottom;
    return (typeof bottom === 'number' ? "".concat(bottom, "px") : bottom);
}, function (_a) {
    var left = _a.left;
    return (typeof left === 'number' ? "".concat(left, "px") : left);
}, function (_a) {
    var right = _a.right;
    return (typeof right === 'number' ? "".concat(right, "px") : right);
}, DEFAULT_COLORS.gray.s80);
var templateObject_1$6;

var GET_INTERACTIVE_BANNER_QUERY_KEY = ['useGetInteractiveBanner'];
var getInteractiveBanner = function (configs) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get('/discovery/api/v1/web/main/cpt', configs)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
function useGetInteractiveBanner() {
    var _a;
    var _b = useQuery({
        queryKey: GET_INTERACTIVE_BANNER_QUERY_KEY,
        queryFn: getInteractiveBanner,
    }), data = _b.data, query = __rest(_b, ["data"]);
    return __assign({ data: data, banners: (data === null || data === void 0 ? void 0 : data.inventories) || [], firstBanner: (_a = data === null || data === void 0 ? void 0 : data.inventories) === null || _a === void 0 ? void 0 : _a[0] }, query);
}

/**
 * 숫자를 0과 1 사이로 제한
 */
var clamp01 = function (v) { return Math.max(0, Math.min(1, v)); };
/**
 * Ease-out cubic 이징 함수
 */
var easeOutCubic = function (t) { return 1 - Math.pow(1 - t, 3); };

// 스와이프 방향과 현재 상태에 따라 다음 상태 결정
var determineNextStep = function (currentStep, isSwipeUp) {
    if (isSwipeUp) {
        // 위로 스와이프: EXPANDED 방향으로 이동
        if (currentStep === 'EXPANDED')
            return 'EXPANDED';
        if (currentStep === 'COMPACT')
            return 'EXPANDED';
        // CONTENT 상태: offset이 0이면 COMPACT, 아니면 CONTENT 유지
        var scrollY_1 = window.scrollY || window.pageYOffset;
        return scrollY_1 === 0 ? 'COMPACT' : 'CONTENT';
    }
    else {
        // 아래로 스와이프: CONTENT 방향으로 이동
        if (currentStep === 'EXPANDED')
            return 'COMPACT';
        if (currentStep === 'COMPACT')
            return 'CONTENT';
        return 'CONTENT';
    }
};
var useShrinkingBannerAnimation = function (_a) {
    var animationMode = _a.animationMode, bannerRef = _a.bannerRef, originalHeight = _a.originalHeight, initialStep = _a.initialStep, _b = _a.enabled, enabled = _b === void 0 ? true : _b, targetRef = _a.targetRef;
    // Shrinking Banner 상수
    var SHRINKING_BANNER = useMemo(function () { return ({
        MIN_HEIGHT: SHRINKING_BANNER_CONSTANTS.MIN_HEIGHT,
        MAX_HEIGHT: originalHeight,
        SHRINK_DISTANCE: originalHeight - SHRINKING_BANNER_CONSTANTS.MIN_HEIGHT, // MAX_HEIGHT - MIN_HEIGHT
        SNAP_DURATION: SHRINKING_BANNER_CONSTANTS.SNAP_DURATION,
        SWIPE_THRESHOLD: SHRINKING_BANNER_CONSTANTS.SWIPE_THRESHOLD,
    }); }, [originalHeight]);
    var initialStepValue = useMemo(function () {
        if (initialStep)
            return initialStep;
        return 'EXPANDED';
    }, [initialStep]);
    var _c = useMemo(function () {
        if (initialStepValue === 'EXPANDED')
            return { offset: 0, progress: 0 };
        var safeShrinkDistance = Math.max(0, SHRINKING_BANNER.SHRINK_DISTANCE);
        return { offset: safeShrinkDistance, progress: 1 };
    }, [initialStepValue, SHRINKING_BANNER.SHRINK_DISTANCE]), initialOffset = _c.offset, initialProgress = _c.progress;
    var stepRef = useRef(initialStepValue);
    var offsetRef = useRef(initialOffset);
    var _d = useState(initialProgress), progress = _d[0], setProgress = _d[1];
    var progressRef = useRef(initialProgress);
    // animationMode나 initialStep이 변경되면 상태를 초기화
    useEffect(function () {
        stepRef.current = initialStepValue;
        offsetRef.current = initialOffset;
        progressRef.current = initialProgress;
        setProgress(initialProgress);
    }, [animationMode, initialStepValue, initialOffset, initialProgress]);
    var lastTouchYRef = useRef(0);
    var touchStartYRef = useRef(0);
    var isTouchingRef = useRef(false);
    var scrollStartYRef = useRef(0);
    var isScrollingRef = useRef(false);
    var snapRafRef = useRef(null);
    var touchMoveRafRef = useRef(null);
    // 배너 상태를 설정하는 공통 함수
    var setBannerState = useCallback(function (step, offset, progressValue) {
        offsetRef.current = offset;
        progressRef.current = progressValue;
        setProgress(progressValue);
        stepRef.current = step;
    }, []);
    var animateSnap = useCallback(function (from, to, onDone) {
        var start = Date.now();
        var frame = function () {
            var t = clamp01((Date.now() - start) / SHRINKING_BANNER.SNAP_DURATION);
            var eased = easeOutCubic(t);
            var value = from + (to - from) * eased;
            offsetRef.current = value;
            var newProgress = value / SHRINKING_BANNER.SHRINK_DISTANCE;
            // 진행률이 크게 변할 때만 상태 업데이트
            if (Math.abs(newProgress - progressRef.current) >
                SHRINKING_BANNER_CONSTANTS.PROGRESS_UPDATE_THRESHOLD ||
                t >= 1) {
                progressRef.current = newProgress;
                setProgress(newProgress);
            }
            if (t < 1) {
                snapRafRef.current = requestAnimationFrame(frame);
            }
            else {
                onDone === null || onDone === void 0 ? void 0 : onDone();
            }
        };
        snapRafRef.current = requestAnimationFrame(frame);
    }, [SHRINKING_BANNER.SHRINK_DISTANCE]);
    var onTouchStart = useCallback(function (e) {
        // 다이얼로그 등으로 body 스크롤이 잠긴 상태에서는 배너 터치 무시
        if (document.body.style.overflow === 'hidden') {
            isTouchingRef.current = false;
            return;
        }
        isTouchingRef.current = true;
        var startY = e.touches[0].clientY;
        touchStartYRef.current = startY;
        lastTouchYRef.current = startY;
    }, []);
    var onTouchMove = useCallback(function (e) {
        if (!isTouchingRef.current)
            return;
        var currentY = e.touches[0].clientY;
        var delta = lastTouchYRef.current - currentY; // delta > 0: 위로 밀어 배너 축소, delta < 0: 아래로 당겨 배너 확장
        lastTouchYRef.current = currentY;
        var step = stepRef.current;
        var scrollY = window.scrollY || window.pageYOffset;
        // 1) step: CONTENT
        // CONTENT 상태에서는 기본적으로 페이지 스크롤을 우선한다.
        // - 스크롤이 이미 내려가 있으면(scrollY > 0): 배너는 관여하지 않음
        // - 스크롤이 최상단(scrollY === 0)에서 아래로 당기는 경우(delta < 0):
        //   pull-to-refresh 등 브라우저 기본 동작을 막기 위해 preventDefault 처리
        // 이후 배너 offset은 변경하지 않고 종료한다.
        if (step === 'CONTENT') {
            if (scrollY === 0 && delta < 0 && e.cancelable) {
                e.preventDefault();
            }
            return;
        }
        // 2) step: COMPACT
        // COMPACT 상태에서,
        // 이미 최소 높이(offset이 최대)에 도달한 상태에서
        // 더 위로 밀어 축소하려는 제스처(delta > 0)가 들어오면
        // 배너 제어를 종료하고 CONTENT 상태로 전환한다.
        var atMaxOffset = offsetRef.current >= SHRINKING_BANNER.SHRINK_DISTANCE;
        if (step === 'COMPACT' && delta > 0 && atMaxOffset) {
            stepRef.current = 'CONTENT';
            return;
        }
        // 3) step: EXPANDED
        // 배너가 이미 최대 확장(EXPANDED) 상태이고,
        // 페이지가 최상단이 아닐 때
        // 더 확장하려는 드래그(아래로 당기기)는
        // 스크롤 차단을 방지하기 위해 무시한다.
        if (step === 'EXPANDED' && offsetRef.current === 0 && delta < 0) {
            return;
        }
        // Only prevent default if the event is cancelable
        if (e.cancelable) {
            e.preventDefault();
        }
        var nextOffset = Math.max(0, Math.min(offsetRef.current + delta, SHRINKING_BANNER.SHRINK_DISTANCE));
        offsetRef.current = nextOffset;
        // RAF 스케줄링
        if (touchMoveRafRef.current == null) {
            touchMoveRafRef.current = requestAnimationFrame(function () {
                touchMoveRafRef.current = null;
                var distance = SHRINKING_BANNER.SHRINK_DISTANCE;
                var currentProgress = distance === 0 ? 0 : offsetRef.current / distance;
                if (Math.abs(currentProgress - progressRef.current) >
                    SHRINKING_BANNER_CONSTANTS.TOUCH_MOVE_UPDATE_THRESHOLD) {
                    progressRef.current = currentProgress;
                    setProgress(currentProgress);
                }
            });
        }
    }, [SHRINKING_BANNER.SHRINK_DISTANCE]);
    var onTouchEnd = useCallback(function (e) {
        if (!isTouchingRef.current)
            return;
        isTouchingRef.current = false;
        // 터치 이동 방향 판단: delta > 0이면 아래로 스와이프 (배너 축소), delta < 0이면 위로 스와이프 (배너 확장)
        var touchEndY = e.changedTouches[0].clientY;
        var touchDelta = touchStartYRef.current - touchEndY; // 최소 이동 거리 적용: threshold보다 작은 값은 0으로 처리 (클릭과 스와이프 구분)
        var absTouchDelta = Math.abs(touchDelta);
        if (absTouchDelta < SHRINKING_BANNER.SWIPE_THRESHOLD) {
            touchDelta = 0;
            return;
        }
        var current = offsetRef.current;
        var currentStep = stepRef.current;
        var isSwipeUp = touchDelta < 0;
        var nextStep = determineNextStep(currentStep, isSwipeUp);
        stepRef.current = nextStep;
        var targetOffset = nextStep === 'EXPANDED' ? 0 : SHRINKING_BANNER.SHRINK_DISTANCE;
        animateSnap(current, targetOffset);
    }, [SHRINKING_BANNER.SHRINK_DISTANCE, animateSnap]);
    var onScroll = useCallback(function () {
        if (!isScrollingRef.current) {
            // 스크롤 시작 시점의 위치 저장
            scrollStartYRef.current = window.scrollY || window.pageYOffset;
            isScrollingRef.current = true;
        }
    }, []);
    var onScrollEnd = useCallback(function () {
        isScrollingRef.current = false; // 스크롤 방향 판단: scrollDelta > 0이면 위로 스크롤 (스크롤 위치 감소), scrollDelta < 0이면 아래로 스크롤 (스크롤 위치 증가)
        var currentScrollY = window.scrollY || window.pageYOffset;
        var scrollDelta = scrollStartYRef.current - currentScrollY;
        var isSwipeUp = scrollDelta < 0;
        if (stepRef.current === 'CONTENT') {
            var bannerElement = bannerRef.current;
            if (bannerElement && currentScrollY > 0) {
                // compact 영역 중간에서 스크롤이 끝난 경우
                // 배너의 원래 top/bottom 위치를 기준으로 스냅
                var nextStep = determineNextStep(stepRef.current, isSwipeUp);
                stepRef.current = nextStep;
                return;
            }
            // 스크롤이 0일 때는 기존 로직 유지
            if (currentScrollY === 0) {
                // 위로 스크롤한 경우 (scrollDelta > 0) 배너를 확장할 수 있음
                if (scrollDelta > 0) {
                    setBannerState('COMPACT', SHRINKING_BANNER.SHRINK_DISTANCE, 1);
                    return;
                }
            }
            return;
        }
    }, [SHRINKING_BANNER.SHRINK_DISTANCE, animateSnap]);
    useEffect(function () {
        var _a;
        var touchTarget = (_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) !== null && _a !== void 0 ? _a : window;
        var cleanup = function () {
            touchTarget.removeEventListener('touchstart', onTouchStart);
            touchTarget.removeEventListener('touchmove', onTouchMove);
            touchTarget.removeEventListener('touchend', onTouchEnd);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('scrollend', onScrollEnd);
            if (snapRafRef.current != null) {
                cancelAnimationFrame(snapRafRef.current);
            }
            if (touchMoveRafRef.current != null) {
                cancelAnimationFrame(touchMoveRafRef.current);
            }
        };
        if (originalHeight <= 0)
            return;
        if (!enabled) {
            return cleanup;
        }
        // 초기 스크롤 위치 저장
        scrollStartYRef.current = window.scrollY || window.pageYOffset;
        touchTarget.addEventListener('touchstart', onTouchStart, { passive: true });
        touchTarget.addEventListener('touchmove', onTouchMove, { passive: false });
        touchTarget.addEventListener('touchend', onTouchEnd, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('scrollend', onScrollEnd, { passive: true });
        return cleanup;
    }, [
        animationMode,
        SHRINKING_BANNER,
        onTouchStart,
        onTouchMove,
        onTouchEnd,
        onScroll,
        onScrollEnd,
        enabled,
        targetRef,
    ]);
    var containerHeight = useMemo(function () {
        // originalHeight가 아직 측정되지 않았으면 기본값 반환
        if (originalHeight <= 0) {
            if (initialStepValue === 'COMPACT' || initialStepValue === 'CONTENT') {
                return SHRINKING_BANNER.MIN_HEIGHT;
            }
            return SHRINKING_BANNER.MIN_HEIGHT;
        }
        // FIX 모드일 때는 initialStep에 따라 고정 높이 반환
        if (animationMode === 'FIX') {
            if (initialStepValue === 'EXPANDED') {
                return SHRINKING_BANNER.MAX_HEIGHT;
            }
            if (initialStepValue === 'COMPACT' || initialStepValue === 'CONTENT') {
                return SHRINKING_BANNER.MIN_HEIGHT;
            }
        }
        // AUTO 모드일 때는 progress에 따라 동적 높이 반환
        return SHRINKING_BANNER.MAX_HEIGHT - progress * SHRINKING_BANNER.SHRINK_DISTANCE;
    }, [
        animationMode,
        initialStepValue,
        progress,
        originalHeight,
        SHRINKING_BANNER.MAX_HEIGHT,
        SHRINKING_BANNER.MIN_HEIGHT,
        SHRINKING_BANNER.SHRINK_DISTANCE,
    ]);
    // FIX 모드일 때는 progress를 initialStep에 맞게 고정
    if (animationMode === 'FIX') {
        return {
            progress: initialStepValue === 'EXPANDED' ? 0 : 1,
            containerHeight: containerHeight,
        };
    }
    // AUTO 모드일 때는 동적 progress 반환
    return {
        progress: progress,
        containerHeight: containerHeight,
    };
};

var LoggingChargedImpression$1 = weblog.LoggingChargedImpression;
function InteractiveBannerMobile(_a) {
    var logData = _a.logData, generateAdBannerLogData = _a.generateAdBannerLogData, handleSendBannerClickLog = _a.handleSendBannerClickLog, handleSendCloseButtonClickLog = _a.handleSendCloseButtonClickLog;
    var isMobileWeb = useDeviceIdentifier().isMobileWeb;
    var banners = useGetInteractiveBanner().banners;
    var _b = useState(false), isFolded = _b[0], setIsFolded = _b[1];
    var firstBanner = banners === null || banners === void 0 ? void 0 : banners[0];
    var bannerId = firstBanner === null || firstBanner === void 0 ? void 0 : firstBanner.adMeta.id;
    var redirectTo = firstBanner === null || firstBanner === void 0 ? void 0 : firstBanner.adMeta.redirectTo;
    var isExternalObject = (firstBanner === null || firstBanner === void 0 ? void 0 : firstBanner.campaignObjectType) === 'EXTERNAL';
    var closeExposureInteractiveBanner = usePutCloseExposureInteractiveBanner().mutate;
    var baseLogData = generateAdBannerLogData(firstBanner);
    var linkUrl = useMemo(function () {
        return getDeviceOptimalUrl({
            baseUrl: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.url,
            desktopUrl: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop,
            isMobileWeb: isMobileWeb,
        });
    }, [redirectTo, isMobileWeb]);
    var handleClickBanner = useCallback(function () {
        if (!baseLogData)
            return;
        handleSendBannerClickLog(0, baseLogData);
        if (linkUrl)
            window.open(linkUrl, '_blank');
    }, [linkUrl, handleSendBannerClickLog]);
    var handleCloseBanner = useCallback(function () {
        if (!baseLogData)
            return;
        handleSendCloseButtonClickLog(baseLogData);
        if (bannerId)
            closeExposureInteractiveBanner(bannerId);
        setIsFolded(true);
    }, [bannerId, closeExposureInteractiveBanner, handleSendCloseButtonClickLog]);
    var shouldShowBanner = baseLogData && (banners === null || banners === void 0 ? void 0 : banners.length) > 0;
    return (jsx(Fragment, { children: shouldShowBanner && (jsx(Container$4, { isFolded: isFolded, children: jsxs(BannerWrapper, { children: [isExternalObject && jsx(ExternalBannerLabel, { top: 12, left: 12 }), jsx(LoggingChargedImpression$1, __assign({}, logData, { params: __assign({}, baseLogData), chargedImpressionOptions: {
                            key: "advertisement-interactive-banner-".concat(logData.screenName, "-").concat(baseLogData.ad_data.ad_inventory_id),
                        }, children: jsx(BannerImageContainer, { children: jsx(BannerImage, { src: firstBanner === null || firstBanner === void 0 ? void 0 : firstBanner.image, hasUrl: !!linkUrl, onClick: handleClickBanner }) }) })), jsx(CloseButton$2, { onClick: handleCloseBanner, children: jsx(Icon, { name: "IcoClose", color: DEFAULT_COLORS.gray.s500, size: 20 }) })] }) })) }));
}
var Container$4 = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: calc(100% - 40px);\n  box-sizing: border-box;\n  margin: ", ";\n  max-height: ", ";\n  opacity: ", ";\n  overflow: hidden;\n  transition: all 0.4s ease;\n"], ["\n  display: flex;\n  justify-content: center;\n  width: calc(100% - 40px);\n  box-sizing: border-box;\n  margin: ", ";\n  max-height: ", ";\n  opacity: ", ";\n  overflow: hidden;\n  transition: all 0.4s ease;\n"])), function (_a) {
    var _b = _a.isFolded, isFolded = _b === void 0 ? false : _b;
    return (isFolded ? '0px 20px' : '10px 20px');
}, function (_a) {
    var _b = _a.isFolded, isFolded = _b === void 0 ? false : _b;
    return (isFolded ? '0' : 'none');
}, function (_a) {
    var _b = _a.isFolded, isFolded = _b === void 0 ? false : _b;
    return (isFolded ? 0.6 : 1);
});
var BannerWrapper = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n"], ["\n  width: 100%;\n  position: relative;\n"])));
var BannerImageContainer = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1/1;\n  border-radius: 12px;\n  background-color: ", "; // \uC2A4\uCF08\uB808\uD1A4 \uBC30\uACBD\uC0C9\n  overflow: hidden;\n"], ["\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1/1;\n  border-radius: 12px;\n  background-color: ", "; // \uC2A4\uCF08\uB808\uD1A4 \uBC30\uACBD\uC0C9\n  overflow: hidden;\n"])), DEFAULT_COLORS.gray.s80);
var BannerImage = styled(OptimizedImage)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  cursor: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  cursor: ", ";\n"])), function (_a) {
    var hasUrl = _a.hasUrl;
    return (hasUrl ? 'pointer' : 'default');
});
var CloseButton$2 = styled.button(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  background-color: ", ";\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 1;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);\n\n  &:active {\n    opacity: 0.8;\n  }\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  background-color: ", ";\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 1;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);\n\n  &:active {\n    opacity: 0.8;\n  }\n"])), DEFAULT_COLORS.white);
var templateObject_1$5, templateObject_2$5, templateObject_3$3, templateObject_4$3, templateObject_5$3;

var LoggingChargedImpression = weblog.LoggingChargedImpression;
function InteractiveBannerPC(_a) {
    var logData = _a.logData, generateAdBannerLogData = _a.generateAdBannerLogData, handleSendBannerClickLog = _a.handleSendBannerClickLog;
    var isMobile = useDeviceIdentifier().isMobile;
    var banners = useGetInteractiveBanner().banners;
    var isSingleBanner = (banners === null || banners === void 0 ? void 0 : banners.length) === 1;
    var _b = useState(0), activeBannerIndex = _b[0], setActiveBannerIndex = _b[1];
    var activeBanner = banners === null || banners === void 0 ? void 0 : banners[activeBannerIndex];
    var emblaAutoplay = useMemo(function () {
        if (isSingleBanner)
            return undefined;
        return [Autoplay({ delay: AUTO_SLIDE_DURATION, stopOnInteraction: false })];
    }, [isSingleBanner]);
    var _c = useEmblaCarousel({
        loop: !isSingleBanner,
        watchDrag: isMobile && !isSingleBanner, // 브라우저 너비 줄인 케이스 최소분기 : 스와이핑 + 버튼 미제공
    }, emblaAutoplay), emblaRef = _c[0], emblaApi = _c[1];
    var scrollPrev = useCallback(function () { return emblaApi && emblaApi.scrollPrev(); }, [emblaApi]);
    var scrollNext = useCallback(function () { return emblaApi && emblaApi.scrollNext(); }, [emblaApi]);
    useEffect(function () {
        if (emblaApi) {
            var onSelect = function () {
                setActiveBannerIndex(emblaApi.selectedScrollSnap());
            };
            emblaApi.on('select', onSelect);
            onSelect();
        }
    }, [emblaApi]);
    var handleClickBanner = useCallback(function (url, index, baseLogData) {
        handleSendBannerClickLog(index, baseLogData);
        if (!url)
            return;
        window.open(url, '_blank');
    }, [handleSendBannerClickLog]);
    var shouldShowBanner = (banners === null || banners === void 0 ? void 0 : banners.length) > 0;
    if (!shouldShowBanner)
        return null;
    return (jsx(Container$3, { children: jsxs(SlideContainer, { children: [!isSingleBanner && (jsx(SlideButton, { onClick: scrollPrev, isNext: false, children: jsx(Icon, { name: "IcoChevronLeft", size: 24, color: DEFAULT_COLORS.white }) })), !isSingleBanner && (jsx(SlideButton, { onClick: scrollNext, isNext: true, children: jsx(Icon, { name: "IcoChevronRight", size: 24, color: DEFAULT_COLORS.white }) })), jsx(SlideWrapper, { ref: emblaRef, children: jsx(SlideList, { children: React.Children.toArray(banners.map(function (banner, index) {
                            var baseLogData = generateAdBannerLogData(banner);
                            if (!baseLogData)
                                return null;
                            return (jsx(SlideItem, { onClick: function () {
                                    return handleClickBanner(banner.adMeta.redirectTo.url, index, baseLogData);
                                }, children: jsxs(LoggingChargedImpression, __assign({}, logData, { params: __assign({}, baseLogData), chargedImpressionOptions: {
                                        key: "advertisement-interactive-banner-".concat(logData.screenName, "-").concat(banner.adMeta.id),
                                    }, children: [jsx(SlideBannerImage, { src: banner.image, alt: "ads-interactive-banner-".concat(banner.adMeta.id), hasUrl: !!banner.adMeta.redirectTo.url }), (activeBanner === null || activeBanner === void 0 ? void 0 : activeBanner.campaignObjectType) === 'EXTERNAL' && (jsxs(Fragment, { children: [jsx(ExternalBannerShade, {}), jsx(ExternalBannerLabel, { bottom: isMobile ? 12 : 24, right: isMobile ? '10px' : 'calc(50% - 616px)' })] }))] })) }, banner.adMeta.id));
                        })) }) })] }) }));
}
var Container$3 = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  max-height: 380px;\n  background-color: ", ";\n\n  // \uBE0C\uB77C\uC6B0\uC800 \uB108\uBE44 \uC904\uC778 \uCF00\uC774\uC2A4 \uCD5C\uC18C\uBD84\uAE30 : \uACE0\uC815height \uC544\uB2CC \uBE44\uC728\uCC98\uB9AC\n  ", " {\n    height: auto;\n    margin-bottom: 10px;\n  }\n"], ["\n  max-height: 380px;\n  background-color: ", ";\n\n  // \uBE0C\uB77C\uC6B0\uC800 \uB108\uBE44 \uC904\uC778 \uCF00\uC774\uC2A4 \uCD5C\uC18C\uBD84\uAE30 : \uACE0\uC815height \uC544\uB2CC \uBE44\uC728\uCC98\uB9AC\n  ", " {\n    height: auto;\n    margin-bottom: 10px;\n  }\n"])), DEFAULT_COLORS.gray.s80, media.mobile);
var SlideContainer = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  position: relative;\n  max-width: 1920px;\n  margin: 0 auto;\n  overflow: hidden;\n\n  &:hover button {\n    visibility: visible;\n  }\n\n  ", " {\n    button {\n      display: none;\n    }\n  }\n"], ["\n  position: relative;\n  max-width: 1920px;\n  margin: 0 auto;\n  overflow: hidden;\n\n  &:hover button {\n    visibility: visible;\n  }\n\n  ", " {\n    button {\n      display: none;\n    }\n  }\n"])), media.mobile);
var SlideWrapper = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var SlideList = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex; // embla-carousel-react \uC0AC\uC6A9 \uC2DC, \uC2AC\uB77C\uC774\uB4DC\uB4E4 flex-container \uB7A9\uD551 \uD544\uC694\n"], ["\n  display: flex; // embla-carousel-react \uC0AC\uC6A9 \uC2DC, \uC2AC\uB77C\uC774\uB4DC\uB4E4 flex-container \uB7A9\uD551 \uD544\uC694\n"])));
var SlideItem = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  position: relative;\n  flex: 0 0 100%;\n  min-width: 0;\n  max-height: 380px;\n\n  // \uBE0C\uB77C\uC6B0\uC800 \uB108\uBE44 \uC904\uC778 \uCF00\uC774\uC2A4 \uCD5C\uC18C\uBD84\uAE30 : \uACE0\uC815height \uC544\uB2CC \uBE44\uC728\uCC98\uB9AC\n  ", " {\n    height: auto;\n  }\n\n  & > div {\n    width: inherit;\n    height: inherit;\n  }\n"], ["\n  position: relative;\n  flex: 0 0 100%;\n  min-width: 0;\n  max-height: 380px;\n\n  // \uBE0C\uB77C\uC6B0\uC800 \uB108\uBE44 \uC904\uC778 \uCF00\uC774\uC2A4 \uCD5C\uC18C\uBD84\uAE30 : \uACE0\uC815height \uC544\uB2CC \uBE44\uC728\uCC98\uB9AC\n  ", " {\n    height: auto;\n  }\n\n  & > div {\n    width: inherit;\n    height: inherit;\n  }\n"])), media.mobile);
var SlideBannerImage = styled(OptimizedImage)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: ", ";\n"])), function (_a) {
    var hasUrl = _a.hasUrl;
    return (hasUrl ? 'pointer' : 'default');
});
var ExternalBannerShade = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(286.84deg, rgba(0, 0, 0, 0.4) 10.31%, rgba(0, 0, 0, 0) 36.28%);\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(286.84deg, rgba(0, 0, 0, 0.4) 10.31%, rgba(0, 0, 0, 0) 36.28%);\n  z-index: 1;\n"])));
var SlideButton = styled.button(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  visibility: hidden;\n  position: absolute;\n  top: 50%;\n  ", ";\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background: #00000026;\n  backdrop-filter: blur(4px);\n  z-index: 1;\n"], ["\n  visibility: hidden;\n  position: absolute;\n  top: 50%;\n  ", ";\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background: #00000026;\n  backdrop-filter: blur(4px);\n  z-index: 1;\n"])), function (_a) {
    var isNext = _a.isNext;
    return "".concat(isNext ? 'right' : 'left', ": max(calc(50% - 660px), 16px)");
});
var templateObject_1$4, templateObject_2$4, templateObject_3$2, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$1, templateObject_8$1;

function InteractiveBannerSkeleton() {
    return (jsx(Container$2, { children: jsx(SkeletonContainer, { children: jsx(SkeletonFallback, {}) }) }));
}
var Container$2 = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  max-height: 380px;\n\n  ", " {\n    height: auto;\n    display: flex;\n    justify-content: center;\n    margin: 10px 20px;\n    opacity: 1;\n    overflow: hidden;\n    transition: all 0.4s ease;\n  }\n"], ["\n  max-height: 380px;\n\n  ", " {\n    height: auto;\n    display: flex;\n    justify-content: center;\n    margin: 10px 20px;\n    opacity: 1;\n    overflow: hidden;\n    transition: all 0.4s ease;\n  }\n"])), media.mobile);
var SkeletonContainer = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n\n  ", " {\n    height: auto;\n    aspect-ratio: 1/1;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n\n  ", " {\n    height: auto;\n    aspect-ratio: 1/1;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n"])), media.mobile);
var templateObject_1$3, templateObject_2$3;

var sendClickLog = helper.sendClickLog;
function InteractiveBanner() {
    var _a, _b;
    var deviceType = useDeviceIdentifier().deviceType;
    var _c = useGetInteractiveBanner(), data = _c.data, isLoading = _c.isLoading;
    var _d = data || {}, exposureMeta = _d.exposureMeta, adType = _d.type;
    if (isLoading) {
        return jsx(InteractiveBannerSkeleton, {});
    }
    var logData = {
        screenName: ((_a = data === null || data === void 0 ? void 0 : data.exposureMeta) === null || _a === void 0 ? void 0 : _a.screenName) || '',
        pageCategory: ((_b = data === null || data === void 0 ? void 0 : data.exposureMeta) === null || _b === void 0 ? void 0 : _b.screenTitle) || '',
        eventName: 'ad_banner',
    };
    var generateAdBannerLogData = function (inventory) {
        if (!data || !exposureMeta || !adType || !inventory) {
            return null;
        }
        return {
            item_kind: 'banner',
            ad_data: {
                ad_type: adType,
                ad_inventory_id: inventory.adMeta.id,
                ad_inventory_name: inventory.name,
                ad_group_id: inventory.adMeta.groupId,
                ad_campaign_id: inventory.adMeta.campaignId,
                ad_section_name: exposureMeta.sectionName,
                ad_section_title: exposureMeta.sectionTitle,
                ad_campaign_object: inventory.campaignObjectType,
                link_url: inventory.adMeta.redirectTo.url,
                ad_group_target_id: inventory.adMeta.groupTargetId || 0,
                ad_group_target_attributes: inventory.adMeta.groupTargetAttributes || null,
                ad_adapted_user_segments: (data === null || data === void 0 ? void 0 : data.adaptedUserSegments) || null,
            },
            section_vertical_index: exposureMeta.sectionName
                ? AdsBannerSectionVerticalIndexMap[exposureMeta.sectionName]
                : 0,
        };
    };
    var handleSendBannerClickLog = function (itemHorizonIndex, baseLogData) {
        var logBody = __assign(__assign(__assign({}, logData), baseLogData), { item_horizon_index: itemHorizonIndex });
        sendClickLog(logBody);
    };
    var handleSendCloseButtonClickLog = function (baseLogData) {
        var logBody = __assign(__assign(__assign({}, logData), { eventName: 'close_ad_banner' }), baseLogData);
        sendClickLog(logBody);
    };
    return deviceType !== 'desktop' ? (jsx(InteractiveBannerMobile, { logData: logData, generateAdBannerLogData: generateAdBannerLogData, handleSendBannerClickLog: handleSendBannerClickLog, handleSendCloseButtonClickLog: handleSendCloseButtonClickLog })) : (jsx(InteractiveBannerPC, { logData: logData, generateAdBannerLogData: generateAdBannerLogData, handleSendBannerClickLog: handleSendBannerClickLog }));
}
function AdsInteractiveBanner(_a) {
    var defaultUserAgent = _a.defaultUserAgent, defaultWebViewInfo = _a.defaultWebViewInfo;
    return (jsx(DeviceIdentifierProvider, { defaultUserAgent: defaultUserAgent, defaultWebViewInfo: defaultWebViewInfo, children: jsx(ThemeProvider, { theme: DEFAULT_THEME, children: jsx(InteractiveBanner, {}) }) }));
}

function useBannerCookie(bannerId) {
    useEffect(function () {
        if (!bannerId)
            return;
        var currentId = CookieManager.get(CookieKey.INTERACTIVE_BANNER_ID);
        var newId = String(bannerId);
        if (currentId !== newId) {
            CookieManager.set(CookieKey.INTERACTIVE_BANNER_ID, newId);
        }
    }, [bannerId]);
}

function useBannerHeight(bannerRef, animationMode) {
    var _a = useState(0), originalHeight = _a[0], setOriginalHeight = _a[1];
    useEffect(function () {
        var _a;
        var height = (_a = bannerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        if (height) {
            setOriginalHeight(height);
        }
    }, []);
    var backgroundHeight = useMemo(function () {
        return animationMode === 'AUTO'
            ? originalHeight + SHRINKING_BANNER_CONSTANTS.CONTAINER_PADDING
            : originalHeight;
    }, [animationMode, originalHeight]);
    return { originalHeight: originalHeight, backgroundHeight: backgroundHeight };
}

var createCompactLogData = function (baseLogData, compactBanner) {
    var _a;
    if (!baseLogData)
        return undefined;
    return __assign(__assign(__assign({}, baseLogData.data), ((baseLogData === null || baseLogData === void 0 ? void 0 : baseLogData.search_word) && {
        search_word: baseLogData.search_word,
    })), { ad_data: __assign(__assign({}, baseLogData.data.ad_data), { ad_section_name: compactBanner.loggingMeta.sectionName, ad_section_title: compactBanner.loggingMeta.sectionTitle, link_url: (_a = compactBanner.redirectTo) === null || _a === void 0 ? void 0 : _a.desktop }) });
};
function textToHtml(title) {
    try {
        return title.replace(/\n/g, '<br />');
    }
    catch (error) {
        return title;
    }
}
function CompactBanner(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var compactBanner = _a.compactBanner, externalAd = _a.externalAd, progress = _a.progress, logData = _a.logData, onClose = _a.onClose;
    var LoggingImpression = weblog.LoggingImpression, LoggingClick = weblog.LoggingClick;
    var imageUrl = compactBanner.imageUrl, title = compactBanner.title, redirectTo = compactBanner.redirectTo, loggingMeta = compactBanner.loggingMeta;
    var renderedTitle = useMemo(function () {
        var parsedTitle = textToHtml(title);
        if (!externalAd)
            return parsedTitle;
        var classNames = css$1(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n      margin-left: 4px;\n    "], ["\n      color: ", ";\n      ", ";\n      margin-left: 4px;\n    "])), DEFAULT_COLORS.gray.s400, DEFAULT_THEME.typography.captionNormal10);
        return "".concat(parsedTitle, " <span class=").concat(classNames, ">\uAD11\uACE0</span>");
    }, [title, externalAd]);
    var compactLogData = useMemo(function () { return createCompactLogData(logData, compactBanner); }, [logData, compactBanner]);
    var handleClick = useCallback(function () {
        window.open(redirectTo.desktop, '_blank');
    }, [redirectTo.desktop]);
    var handleImageError = useCallback(function (e) {
        e.currentTarget.style.display = 'none';
    }, []);
    var handleCloseClick = useCallback(function (e) {
        e.stopPropagation();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    return (jsx(LoggingImpression, { screenName: (_b = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _b !== void 0 ? _b : '', eventName: (_c = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _c !== void 0 ? _c : '', impressionOptions: {
            key: progress > SHRINKING_BANNER_CONSTANTS.COMPACT_FADE_END
                ? "".concat(logData === null || logData === void 0 ? void 0 : logData.screenName, "-").concat(loggingMeta.sectionName, "-").concat(loggingMeta.sectionTitle)
                : '',
        }, params: compactLogData, pageCategory: loggingMeta.sectionName, children: jsx(LoggingClick, { screenName: (_d = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _d !== void 0 ? _d : '', eventName: (_e = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _e !== void 0 ? _e : '', pageCategory: (_f = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _f !== void 0 ? _f : '', params: __assign(__assign({}, compactLogData), { item_name: '', ad_data: __assign(__assign({}, compactLogData === null || compactLogData === void 0 ? void 0 : compactLogData.ad_data), { link_url: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop }) }), children: jsxs(CompactBannerWrapper, { progress: progress, onClick: handleClick, children: [jsx(ThumbnailWrapper, { style: {
                            opacity: progress > SHRINKING_BANNER_CONSTANTS.COMPACT_FADE_END ? progress : 0,
                        }, children: jsx(Image$1, { src: imageUrl, onError: handleImageError }) }), jsxs(ContentContainer, { children: [jsx(Text, { lineClamp: 2, typography: "captionNormal14", color: DEFAULT_COLORS.gray.s700, dangerouslySetInnerHTML: {
                                    __html: renderedTitle,
                                } }), onClose && (jsx(LoggingClick, { screenName: (_g = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _g !== void 0 ? _g : '', eventName: 'close_ad_banner', pageCategory: (_h = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _h !== void 0 ? _h : '', params: __assign(__assign({}, compactLogData), { item_kind: 'button', ad_data: __assign({}, compactLogData === null || compactLogData === void 0 ? void 0 : compactLogData.ad_data) }), children: jsx(CloseButton$1, { onClick: handleCloseClick, children: jsx(Icon, { name: "IcoClose", color: DEFAULT_COLORS.gray.s800, size: 18 }) }) }))] })] }) }) }));
}
var CompactBanner$1 = memo(CompactBanner);
var CompactBannerWrapper = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  padding: 6px 14px 12px 16px;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  height: ", "px;\n  opacity: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  padding: 6px 14px 12px 16px;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  height: ", "px;\n  opacity: ", ";\n"])), SHRINKING_BANNER_CONSTANTS.MIN_HEIGHT, function (_a) {
    var progress = _a.progress;
    return progress > SHRINKING_BANNER_CONSTANTS.COMPACT_OPACITY_THRESHOLD
        ? progress
        : Math.max(0, progress - SHRINKING_BANNER_CONSTANTS.COMPACT_FADE_START);
});
var CloseButton$1 = styled.button(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var ThumbnailWrapper = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  height: 100%;\n  border-radius: 4px;\n  overflow: hidden;\n  aspect-ratio: 1 / 1;\n"], ["\n  height: 100%;\n  border-radius: 4px;\n  overflow: hidden;\n  aspect-ratio: 1 / 1;\n"])));
var Image$1 = styled.img(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var ContentContainer = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  flex: 1 0 0;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  flex: 1 0 0;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1;

var BANNER_VARIANTS = {
    SOLO: {
        borderRadius: '12px',
        aspectRatio: '358/296',
    },
    WITH_CTA: {
        borderRadius: '10px',
        aspectRatio: '179/100',
    },
};
var createExpandedLogData = function (baseLogData, expandBanner) {
    if (!baseLogData)
        return undefined;
    return __assign(__assign({}, baseLogData.data), { ad_data: __assign(__assign({}, baseLogData.data.ad_data), { ad_section_name: expandBanner.loggingMeta.sectionName, ad_section_title: expandBanner.loggingMeta.sectionTitle }) });
};
function ExpandBanner(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var expandBanner = _a.expandBanner, externalAd = _a.externalAd, progress = _a.progress, logData = _a.logData, onClose = _a.onClose;
    var LoggingImpression = weblog.LoggingImpression, LoggingClick = weblog.LoggingClick;
    var imageUrl = expandBanner.imageUrl, redirectTo = expandBanner.redirectTo, ctaItems = expandBanner.ctaItems, loggingMeta = expandBanner.loggingMeta;
    var hasCtaItems = ctaItems && ctaItems.length > 0;
    var bannerImageRef = useRef(null);
    var goToPage = useCallback(function (url) {
        if (!url) {
            return;
        }
        window.open(url, '_blank');
    }, []);
    var expandedLogData = useMemo(function () { return createExpandedLogData(logData, expandBanner); }, [logData, expandBanner]);
    var bannerScale = useMemo(function () {
        var _a, _b;
        var bannerImageHeight = (_b = (_a = bannerImageRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
        if (bannerImageHeight <= 0)
            return 1;
        var MIN_BANNER_HEIGHT = SHRINKING_BANNER_CONSTANTS.MIN_BANNER_HEIGHT;
        var minScale = MIN_BANNER_HEIGHT / bannerImageHeight;
        return 1 - progress * (1 - minScale);
    }, [progress]);
    var handleImageError = useCallback(function (e) {
        e.currentTarget.style.display = 'none';
    }, []);
    var handleCloseClick = useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    return (jsxs(Container$1, { hasCtaItems: hasCtaItems, style: {
            opacity: 1 - progress,
            zIndex: progress < SHRINKING_BANNER_CONSTANTS.EXPANDED_OPACITY_THRESHOLD ? 10 : 0,
        }, children: [jsx(LoggingImpression, { screenName: (_b = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _b !== void 0 ? _b : '', eventName: (_c = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _c !== void 0 ? _c : '', impressionOptions: { key: "".concat(loggingMeta.sectionName, "-").concat(loggingMeta.sectionTitle) }, params: __assign(__assign({}, expandedLogData), { ad_data: __assign(__assign({}, expandedLogData === null || expandedLogData === void 0 ? void 0 : expandedLogData.ad_data), { link_url: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop }) }), pageCategory: loggingMeta.sectionName, children: jsx(LoggingClick, { screenName: (_d = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _d !== void 0 ? _d : '', eventName: (_e = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _e !== void 0 ? _e : '', pageCategory: (_f = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _f !== void 0 ? _f : '', params: __assign(__assign({}, expandedLogData), { item_name: '', cta_type: 'image', ad_data: __assign(__assign({}, expandedLogData === null || expandedLogData === void 0 ? void 0 : expandedLogData.ad_data), { link_url: redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop }) }), children: jsxs(BannerImageWrapper, { ref: bannerImageRef, variant: hasCtaItems ? 'WITH_CTA' : 'SOLO', onClick: function () { var _a; return goToPage((_a = redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.desktop) !== null && _a !== void 0 ? _a : ''); }, scale: bannerScale, children: [onClose && (jsx(LoggingClick, { screenName: (_g = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _g !== void 0 ? _g : '', eventName: 'close_ad_banner', pageCategory: (_h = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _h !== void 0 ? _h : '', params: __assign(__assign({}, expandedLogData), { item_kind: 'button', ad_data: __assign({}, expandedLogData === null || expandedLogData === void 0 ? void 0 : expandedLogData.ad_data) }), children: jsx(CloseButton, { onClick: handleCloseClick, children: jsx(Icon, { name: "IcoClose", color: DEFAULT_COLORS.white, size: 18 }) }) })), externalAd && jsx(AdLabel, { children: "\uAD11\uACE0" }), jsx(Image, { src: imageUrl, alt: "interactive banner", onError: handleImageError })] }) }) }), hasCtaItems && (jsx(CtaItemsContainer, { children: ctaItems === null || ctaItems === void 0 ? void 0 : ctaItems.map(function (ctaItem, index) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    return (jsx(LoggingImpression, { screenName: (_a = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _a !== void 0 ? _a : '', eventName: (_b = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _b !== void 0 ? _b : '', impressionOptions: {
                            key: "".concat(loggingMeta.sectionName, "-").concat(loggingMeta.sectionTitle, "-").concat(ctaItem.label),
                        }, params: __assign({}, expandedLogData), pageCategory: loggingMeta.sectionName, children: jsx(LoggingClick, { screenName: (_c = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _c !== void 0 ? _c : '', eventName: (_d = logData === null || logData === void 0 ? void 0 : logData.eventName) !== null && _d !== void 0 ? _d : '', pageCategory: (_e = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _e !== void 0 ? _e : '', params: __assign(__assign({}, expandedLogData), { item_name: ctaItem.label, cta_type: "CTA".concat(index + 1), ad_data: __assign(__assign({}, expandedLogData === null || expandedLogData === void 0 ? void 0 : expandedLogData.ad_data), { link_url: (_f = ctaItem.redirectTo) === null || _f === void 0 ? void 0 : _f.desktop }) }), children: jsxs(CtaItemWrapper, { onClick: function () { var _a; return goToPage((_a = ctaItem.redirectTo) === null || _a === void 0 ? void 0 : _a.desktop); }, children: [ctaItem.imageUrl && (jsx(Image, { src: ctaItem.imageUrl, alt: ctaItem.label, onError: handleImageError })), ctaItem.label && jsx(CtaItemLabel, { children: ctaItem.label })] }, ctaItem.label) }) }, "".concat((_g = ctaItem === null || ctaItem === void 0 ? void 0 : ctaItem.label) !== null && _g !== void 0 ? _g : 'cta-item', "-").concat(index)));
                }) }))] }));
}
var Container$1 = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  max-width: 100%;\n  max-height: 100%;\n  padding: ", ";\n  flex-direction: column;\n  gap: 10px;\n  min-height: ", "px;\n"], ["\n  position: relative;\n  display: flex;\n  max-width: 100%;\n  max-height: 100%;\n  padding: ", ";\n  flex-direction: column;\n  gap: 10px;\n  min-height: ", "px;\n"])), function (_a) {
    var hasCtaItems = _a.hasCtaItems;
    return (hasCtaItems ? '6px 16px 10px 16px' : '6px 16px 16px 16px');
}, SHRINKING_BANNER_CONSTANTS.MIN_HEIGHT);
var CloseButton = styled.button(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  background: rgba(0, 0, 0, 0.3);\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  background: rgba(0, 0, 0, 0.3);\n"])));
var AdLabel = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  ", ";\n  color: #ffffffb2;\n"], ["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  ", ";\n  color: #ffffffb2;\n"])), function (_a) {
    var typography = _a.theme.typography;
    return typography.captionNormal11;
});
var BannerImageWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: hidden;\n  aspect-ratio: ", ";\n  border-radius: ", ";\n  transform-origin: top left;\n  transform: translateZ(0) scale(", ");\n"], ["\n  overflow: hidden;\n  aspect-ratio: ", ";\n  border-radius: ", ";\n  transform-origin: top left;\n  transform: translateZ(0) scale(", ");\n"])), function (_a) {
    var variant = _a.variant;
    return BANNER_VARIANTS[variant].aspectRatio;
}, function (_a) {
    var variant = _a.variant;
    return BANNER_VARIANTS[variant].borderRadius;
}, function (_a) {
    var scale = _a.scale;
    return scale;
});
var Image = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var CtaItemsContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  gap: 10px;\n  aspect-ratio: 195/49;\n  overflow: hidden;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  gap: 10px;\n  aspect-ratio: 195/49;\n  overflow: hidden;\n"])));
var CtaItemWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  aspect-ratio: 174/89;\n"], ["\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  aspect-ratio: 174/89;\n"])));
var CtaItemLabel = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  color: #fff;\n  padding: 4px 10px 5px 10px;\n  background: rgba(0, 0, 0, 0.24);\n  backdrop-filter: blur(10px);\n  text-align: center;\n  ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  color: #fff;\n  padding: 4px 10px 5px 10px;\n  background: rgba(0, 0, 0, 0.24);\n  backdrop-filter: blur(10px);\n  text-align: center;\n  ", ";\n"])), function (_a) {
    var typography = _a.theme.typography;
    return typography.paragraphNormal13;
});
var ExpandBanner$1 = memo(ExpandBanner);
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var createDefaultLogData = function (banner, logData) {
    var _a, _b;
    if (!banner)
        return undefined;
    return __assign({ eventName: 'ad_banner', data: {
            item_kind: 'banner',
            ad_data: {
                ad_type: 'INTERACTIVE_BANNER',
                ad_inventory_id: String(banner.adMeta.id),
                ad_inventory_name: banner.name,
                ad_group_id: String(banner.adMeta.groupId),
                ad_campaign_id: String(banner.adMeta.campaignId),
                ad_campaign_object: banner.campaignObjectType,
                ad_adapted_user_segments: (_a = banner.adaptedUserSegments) !== null && _a !== void 0 ? _a : [],
                ad_group_target_id: banner.adMeta.groupTargetId || 0,
            },
        }, screenName: (_b = logData === null || logData === void 0 ? void 0 : logData.screenName) !== null && _b !== void 0 ? _b : '' }, logData);
};
function AdsShrinkingBannerFeature(_a) {
    var _b, _c;
    var banner = _a.banner, _d = _a.animationMode, animationMode = _d === void 0 ? 'AUTO' : _d, initialStep = _a.initialStep, targetRef = _a.targetRef, logData = _a.logData, className = _a.className, onBannerClose = _a.onBannerClose;
    var bannerRef = useRef(null);
    var _e = useState(false), isClosed = _e[0], setIsClosed = _e[1];
    var closeExposureInteractiveBanner = usePutCloseExposureInteractiveBanner().mutate;
    useBannerCookie((_b = banner === null || banner === void 0 ? void 0 : banner.adMeta) === null || _b === void 0 ? void 0 : _b.id);
    var _f = useBannerHeight(bannerRef, animationMode), originalHeight = _f.originalHeight, backgroundHeight = _f.backgroundHeight;
    var _g = useShrinkingBannerAnimation({
        animationMode: animationMode,
        bannerRef: bannerRef,
        originalHeight: originalHeight,
        initialStep: initialStep,
        enabled: !isClosed && animationMode !== 'FIX',
        targetRef: targetRef,
    }), progress = _g.progress, containerHeight = _g.containerHeight;
    useEffect(function () {
        if (containerHeight && bannerRef.current) {
            bannerRef.current.style.height = "".concat(containerHeight, "px");
        }
    }, [containerHeight]);
    var defaultLogData = useMemo(function () { return createDefaultLogData(banner, logData); }, [banner, logData]);
    var handleCloseBanner = useCallback(function () {
        var _a;
        if (!((_a = banner === null || banner === void 0 ? void 0 : banner.adMeta) === null || _a === void 0 ? void 0 : _a.id))
            return;
        closeExposureInteractiveBanner(banner.adMeta.id);
        setIsClosed(true);
        onBannerClose === null || onBannerClose === void 0 ? void 0 : onBannerClose();
    }, [(_c = banner === null || banner === void 0 ? void 0 : banner.adMeta) === null || _c === void 0 ? void 0 : _c.id, closeExposureInteractiveBanner, onBannerClose]);
    if (!banner || isClosed)
        return null;
    var expanded = banner.expanded, compact = banner.compact, externalAd = banner.externalAd;
    return (jsx(Container, { backgroundHeight: backgroundHeight, className: className, children: jsxs(BannerContent, { ref: bannerRef, children: [expanded && !(animationMode === 'FIX' && initialStep === 'COMPACT') && (jsx(ExpandBanner$1, { expandBanner: expanded, externalAd: externalAd, progress: progress, logData: defaultLogData, onClose: handleCloseBanner })), compact && !(animationMode === 'FIX' && initialStep === 'EXPANDED') && (jsx(CompactBanner$1, { compactBanner: compact, externalAd: externalAd, progress: progress, logData: defaultLogData, onClose: handleCloseBanner }))] }) }));
}
function AdsShrinkingBanner(props) {
    var queryClient = useState(function () { return new QueryClient(); })[0];
    return (jsx(DeviceIdentifierProvider, { children: jsx(ThemeProvider, { theme: DEFAULT_THEME, children: jsx(ErrorBoundary, { name: "AdsShrinkingBanner", fallback: null, children: jsx(QueryClientProvider, { client: queryClient, children: jsx(AdsShrinkingBannerFeature, __assign({}, props)) }) }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: sticky;\n  width: 100%;\n  margin-top: 8px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    min-height: ", "px;\n    background: linear-gradient(to bottom, #fff 0%, #f5f6f7 15.12%);\n  }\n"], ["\n  position: sticky;\n  width: 100%;\n  margin-top: 8px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    min-height: ", "px;\n    background: linear-gradient(to bottom, #fff 0%, #f5f6f7 15.12%);\n  }\n"])), function (_a) {
    var backgroundHeight = _a.backgroundHeight;
    return backgroundHeight;
});
var BannerContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  min-height: ", "px;\n"], ["\n  position: relative;\n  width: 100%;\n  min-height: ", "px;\n"])), SHRINKING_BANNER_CONSTANTS.MIN_HEIGHT);
var AdsShrinkingBanner$1 = memo(AdsShrinkingBanner);
var templateObject_1, templateObject_2;

export { AdsBannerList, AdsBannerListSkeleton, AdsBannerSectionNameMap, AdsBannerSectionVerticalIndexMap, AdsInteractiveBanner, AdsInteractiveBannerSectionNameMap, AdsScreenNameMap, AdsShrinkingBanner$1 as AdsShrinkingBanner, CookieKey, GET_INTERACTIVE_BANNER_QUERY_KEY, getInteractiveBanner, useGetAdsBanners, useGetInteractiveBanner, useShrinkingBannerAnimation };
//# sourceMappingURL=index.esm.js.map
